import React from 'react';
import ReactLoading from 'react-loading';
import Address from './Address';
import BusinessAddress from './BusinessAddress';
import Postmen from './Postmen';
import CartRule from './CartRule';
import ReferralCoupon from './ReferralCoupon';
import WholesalerReseller from './WholesalerReseller';
import PICNumber from './PICNumber';
import CreditCard from './CreditCard';
import AccountHolderInformationForm from './BasicInfo/AccountHolderInformationForm';
import AccountPasswordForm from './BasicInfo/AccountPasswordForm';
import AccountEmailForm from './BasicInfo/AccountEmailForm';
import AccountResellerAccountDeptForm from './BasicInfo/AccountResellerAccountDeptForm';
import AccountResellerPurchaseDeptForm from './BasicInfo/AccountResellerPurchaseDeptForm';
import AccountGovernmentDetailsForm from './BasicInfo/AccountGovernmentDetailsForm';
import AccountBankInformationForm from './BasicInfo/AccountBankInformationForm';
import AccountStripeCredentialForm from './BasicInfo/AccountStripeCredentialForm';
import AccountResellerPaymentMethodsForm from './BasicInfo/AccountResellerPaymentMethodsForm';

function AccountDetailForm(props) {
    const {
        globalConfig = {},
        initialized,
        isLoading,
        memberType,
        userInfo,
        userReAuth,
        submitAccountHolderInformation,
        saveBusinessAddress,
        saveDispatchLocation,
        makeDefaultDispatchLocation,
    } = props;
    const { createAddress, updateAddress, makeDefaultBillingAddress, deleteAddress, deleteDispatchLocation } = props;
    const { createPostman, editPostman, deletePostman } = props;
    const { createCartRule, editCartRule, deleteCartRule, requestCartRule } = props;
    const { createCreditCard, makeDefaultCreditCard, deleteCreditCard } = props;
    const { createPICNumber, makeDefaultPICNumber, deletePICNumber } = props;
    const { deleteWholesalerReseller } = props;
    const { createReferralCoupon } = props;

    const { DisplayPaymentMethodSelector = false } = globalConfig;

    if (!initialized) {
        return (
            <React.Fragment>
                <div
                    className='card card--border'
                    style={{ position: 'relative', height: 200 }}
                >
                    <ReactLoading
                        className='button__spinner'
                        type='spin'
                        color='black'
                        height={50}
                        width={50}
                    />
                </div>
            </React.Fragment>
        );
    }

    return (
        <React.Fragment>
            <div className='card card--border card--form card--stackable'>
                <AccountHolderInformationForm
                    {...props}
                    data={userInfo.basicInfo}
                    businessAddress={userInfo.businessAddress || {}}
                    handleFormSubmission={submitAccountHolderInformation}
                />
            </div>
            {(memberType == 'wholesaler' || memberType == 'reseller' || memberType == 'global member') && (
                <div className='card card--border card--form card--stackable'>
                    <BusinessAddress
                        data={userInfo.businessAddress || {}}
                        memberType={memberType}
                        handleFormSubmission={saveBusinessAddress}
                        handleDispatchLocationFormSubmission={saveDispatchLocation}
                        list={userInfo.availableDispatchLocations.map((item) => {
                            return {
                                ID: item.ID,
                                ...item.Address,
                                IsDefault: item.IsDefault,
                                CanDelete: !item.IsDefault
                            };
                        })}
                        handleMakeDefault={makeDefaultDispatchLocation}
                        handleDelete={deleteDispatchLocation}
                        isLoadingList={isLoading.dispatchLocationList}
                    />
                </div>
            )}
            {(memberType == 'wholesaler' || memberType == 'global member') && (
                <div className='card card--border card--form card--stackable'>
                    <AccountStripeCredentialForm
                        {...props}
                        data={userInfo.basicInfo}
                        handleFormSubmission={submitAccountHolderInformation}
                    />
                </div>
            )}
            {DisplayPaymentMethodSelector === true && (
                <div className='card card--border card--form card--stackable'>
                    <AccountResellerPaymentMethodsForm
                        {...props}
                        userReAuth={userReAuth}
                        data={userInfo.basicInfo}
                        handleFormSubmission={submitAccountHolderInformation}
                    />
                </div>
            )}
            <div className='card card--border card--form card--stackable'>
                <AccountPasswordForm
                    {...props}
                    data={userInfo.basicInfo}
                    handleFormSubmission={submitAccountHolderInformation}
                />
            </div>
            <div className='card card--border card--form card--stackable'>
                <AccountEmailForm
                    {...props}
                    data={userInfo.basicInfo}
                    handleFormSubmission={submitAccountHolderInformation}
                />
            </div>
            {memberType === 'reseller' && (
                <React.Fragment>
                    <div className='card card--border card--form card--stackable'>
                        <AccountResellerAccountDeptForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                    <div className='card card--border card--form card--stackable'>
                        <AccountResellerPurchaseDeptForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                    <div className='card card--border card--form card--stackable'>
                        <AccountGovernmentDetailsForm
                            {...props}
                            data={userInfo.basicInfo}
                            handleFormSubmission={
                                submitAccountHolderInformation
                            }
                        />
                    </div>
                </React.Fragment>
            )}
            {(memberType == 'wholesaler' || memberType == 'global member') && (
                <div className='card card--border card--form card--stackable'>
                    <AccountBankInformationForm
                        {...props}
                        memberType={memberType}
                        data={userInfo.basicInfo}
                        handleFormSubmission={submitAccountHolderInformation}
                    />
                </div>
            )}
            {(memberType !== 'global member') && (
                <div className='card card--border card--form card--stackable'>
                    <Address
                        {...props}
                        memberType={memberType}
                        isLoadingList={isLoading.addressList}
                        list={userInfo.availableAddresses.map((item) => {
                            return {
                                ...item,
                                CanDelete: !(
                                    item.ID == userInfo.defaultDeliveryAddressID ||
                                    (typeof userInfo.defaultBillingAddressID !=
                                        'undefined' &&
                                        item.ID == userInfo.defaultBillingAddressID)
                                ),
                                IsDelivery:
                                    item.ID == userInfo.defaultDeliveryAddressID,
                                IsBilling:
                                    item.ID == userInfo.defaultBillingAddressID,
                            };
                        })}
                        handleFormSubmission={createAddress}
                        handleUpdateFormSubmission={updateAddress}
                        handleMakeDefault={makeDefaultBillingAddress}
                        handleDelete={deleteAddress}
                    />
                </div>
            )}
            {(memberType == 'wholesaler' || memberType == 'global member') && (
                <div className='card card--border card--form card--stackable'>
                    <Postmen
                        {...props}
                        isLoadingList={isLoading.postmenList}
                        list={userInfo.availablePostmen.map((item) => {
                            return item;
                        })}
                        handleCreate={createPostman}
                        handleEdit={editPostman}
                        handleDelete={deletePostman}
                    />
                </div>
            )}
            {memberType == 'wholesaler' && (
                <div className='card card--border card--form card--stackable'>
                    <CartRule
                        {...props}
                        request={requestCartRule}
                        isLoadingList={isLoading.cartRuleList}
                        list={userInfo.availableCartRules.map((item) => {
                            return item;
                        })}
                        handleCreate={createCartRule}
                        handleEdit={editCartRule}
                        handleDelete={deleteCartRule}
                    />
                </div>
            )}
            {/*
            {memberType !== 'global member' && (
                <div className='card card--border card--form card--stackable'>
                    <WholesalerReseller
                        {...props}
                        isLoadingList={isLoading.wholesalerResellerList}
                        list={userInfo.availableWholesalerReseller.map((item) => {
                            return {
                                ...item,
                                CanDelete: !(
                                    item.SupplierID == userInfo.selectedParentID
                                ),
                                IsDefault:
                                    item.SupplierID == userInfo.selectedParentID,
                            };
                        })}
                        handleFormSubmission={() => {}}
                        handleMakeDefault={() => {}}
                        handleDelete={deleteWholesalerReseller}
                    />
                </div>
            )}
            */}
            {(memberType !== 'wholesaler' && memberType !== 'global member' && window.localeCountry === 'Australia') && (
                <div className='card card--border card--form card--stackable'>
                    <PICNumber
                        {...props}
                        isLoadingListreadCombinedShippingMethods={isLoading.picNumberList}
                        list={userInfo.availablePICNumbers.map((item) => {
                            return {
                                ...item,
                                CanDelete: !(
                                    item.ID == userInfo.defaultPICNumberID
                                ),
                                IsDefault:
                                    item.ID == userInfo.defaultPICNumberID,
                            };
                        })}
                        handleFormSubmission={createPICNumber}
                        handleMakeDefault={makeDefaultPICNumber}
                        handleDelete={deletePICNumber}
                    />
                </div>
            )}
            {(memberType !== 'global member') && (
                <div className='card card--border card--form card--stackable'>
                    <CreditCard
                        {...props}
                        isLoadingList={isLoading.creditCardList}
                        list={userInfo.availableCreditCards.map((item) => {
                            return {
                                ...item,
                                CanDelete: !(
                                    item.ID == userInfo.defaultCreditCardID
                                ),
                                IsDefault: item.ID == userInfo.defaultCreditCardID,
                            };
                        })}
                        handleFormSubmission={createCreditCard}
                        handleMakeDefault={makeDefaultCreditCard}
                        handleDelete={deleteCreditCard}
                        currentBillingAddress={userInfo.availableAddresses.find(
                            (item) => item.ID == userInfo.defaultBillingAddressID
                        )}
                    />
                </div>
            )}
            {memberType === 'retail-customer' && (
                <>
                    <div className='card card--border card--form card--stackable'>
                        <ReferralCoupon
                            {...props}
                            isLoadingList={isLoading.referralCouponList}
                            list={userInfo.availableReferralCoupons}
                            handleFormSubmission={createReferralCoupon}
                        />
                    </div>
                    {(userInfo.availableReferralCoupons.length > 0 || window.localeCountry === 'South Africa') && (
                        <>
                            <div className='card card--border card--form card--stackable'>
                                <AccountGovernmentDetailsForm
                                    {...props}
                                    data={userInfo.basicInfo}
                                    handleFormSubmission={
                                        submitAccountHolderInformation
                                    }
                                />
                            </div>
                            {/*
                            <div className='card card--border card--form card--stackable'>
                                <AccountBankInformationForm
                                    {...props}
                                    memberType={memberType}
                                    data={userInfo.basicInfo}
                                    handleFormSubmission={
                                        submitAccountHolderInformation
                                    }
                                />
                            </div>
                            */}
                        </>
                    )}
                </>
            )}
        </React.Fragment>
    );
}

export default AccountDetailForm;
